// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"Body_modalBody__1vAKk","scrollDown":"Body_scrollDown__32vib"};